export default __webpack_public_path__ + "static/media/11@3x.a813ecf5.png";